import WalletSelector from './WalletSelector.container'
export default WalletSelector
